export const GLOBAL_PHONE_LIMIT = 30;
